export default __webpack_public_path__ + "static/media/pdf-icon.6279a47b.png";